const unreadTopicsCount = state => state.unreadTopicsCount;

export default {
    unreadTopicsCount,
};
